"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenericTableRow = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var lodash_1 = __importDefault(require("lodash"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getDefault = function (value) {
    if ([null, undefined, ''].includes(value))
        return '-';
    return value;
};
var GenericTableRow = function (_a) {
    var columns = _a.columns, data = _a.data, tdClassNames = _a.tdClassNames, trClassNames = _a.trClassNames, trOnClick = _a.trOnClick;
    var invalidFields = [];
    columns.forEach(function (c) {
        if (lodash_1.default.get(data, c.field) === undefined && !c.default) {
            invalidFields.push(c.field);
        }
    });
    if (invalidFields.length)
        throw new Error("Table missing data: ".concat(invalidFields.join(', ')));
    return ((0, jsx_runtime_1.jsx)("tr", { className: trClassNames, id: data.id, onClick: function () { return (trOnClick ? trOnClick(data) : undefined); }, children: columns.map(function (c) {
            var classes = [tdClassNames];
            if (c.tdClassNames)
                classes.unshift(c.tdClassNames);
            return ((0, jsx_runtime_1.jsx)("td", { className: classes.join(' '), children: c.formatter ? c.formatter(data) : getDefault(lodash_1.default.get(data, c.field)) }, c.field));
        }) }, data.id));
};
exports.GenericTableRow = GenericTableRow;
